import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Utility } from '../../shared/utility/utility';
import { CashierService } from './cashier.service';
import { PaymentAjaxService } from '../../payment-system/services/payment-ajax.service';
import { MessageService } from './message.service';
import { EmitterService } from '../../services/emitter.service';
import { PAYMENT_METHODS } from '../config/cashier.config';
declare let encryptData: any;

@Injectable({
  providedIn: 'root'
})
export class CreditCardService {
  numOfRequest=0;
  constructor(private utils:Utility, private cahiserService:CashierService, private paymentAjaxService:PaymentAjaxService, 
              private messageService:MessageService, private emitterService:EmitterService) { }
  getCreditCardRequestObject({formDetails,selectedPaymentMethod,amount,playerID}) {
    let expiryMonth,expiryYear,cardNumber,cvv,name,accountId;
    let date = new Date();
    let expiryYearPrefix = date.getFullYear().toString().slice(0, 2);
    let isSavedCard = false;
    let providerName = selectedPaymentMethod.providerType;
    let servcie = selectedPaymentMethod.service;
  
    let requestObj = {
      merchantId: environment.paymentIqMID,
      amount: amount,
      attributes: {
        channelId: this.utils.getOsBrowserType(),
        cancelUrl: window.location.origin + "/redirection.html?transactionType=deposit&paymentMethod="+selectedPaymentMethod.name,
        successUrl: window.location.origin + "/redirection.html?transactionType=deposit&paymentMethod="+selectedPaymentMethod.name,
        failureUrl: window.location.origin + "/redirection.html?transactionType=deposit&paymentMethod="+selectedPaymentMethod.name,
        pendingUrl: window.location.origin + "/redirection.html?transactionType=deposit&paymentMethod="+selectedPaymentMethod.name,
        productId: this.cahiserService.tokenData.productId,
        ipAddr:this.cahiserService.tokenData.ipAddr,
        labelId: this.cahiserService.tokenData.labelId
      },
      sessionId: this.cahiserService.tokenData.token,
      userId: playerID,
      // service: servcie,
      paymentMethod: selectedPaymentMethod.name,
    };

   if(selectedPaymentMethod?.name.includes(PAYMENT_METHODS.CREDITCARD)){
    if(formDetails.controls["accountId"]?.value){
      isSavedCard = true;
      accountId = formDetails.controls['accountId'].value
      name = formDetails.controls['name'].value
      expiryMonth = formDetails.controls['expiryMonth'].value
      expiryYear = formDetails.controls['expiryYear'].value
      cvv = formDetails.controls['cardCvv'].value
      if (typeof encryptData == "function") {
        cvv = encryptData(cvv);
      }
    }else{
        let ccNumber = formDetails.controls["cardNumber"].value;
        let expiry = formDetails.controls["cardExpiry"].value;
        name = formDetails.controls["fullName"].value;

        expiry = expiry.split("/");
        expiryMonth = expiry[0];
        expiryYear = expiry[1];
        cvv=formDetails.controls["cardCvv"].value
        ccNumber = ccNumber.replaceAll(" ", "");
        if (typeof encryptData == "function") {
          cardNumber = encryptData(ccNumber);
          cvv = encryptData(cvv);
        }
    }

    requestObj['cardHolder'] = name;
    requestObj['encCvv'] = cvv;
    requestObj['storeAccount'] = true;

    if(isSavedCard){
      requestObj['accountId'] = accountId;
    }else{
      requestObj['encCreditcardNumber'] = cardNumber;
      requestObj['expiryMonth'] = expiryMonth;
      requestObj['expiryYear'] = expiryYearPrefix + expiryYear;
    }
   }


    return requestObj;
  }

  getTransactionDetails(transactionDetails){
    let transactionId = '';
    if(transactionDetails?.txnId){
      transactionId = transactionDetails?.txnId;
    }else{
      transactionId = localStorage.getItem('txnIdCc');
    }
    this.emitterService.broadCastCashierLoader(true);
    this.updateTransactionDetails(transactionDetails,transactionId)
}
deletSavedCard(userId, accountId, sessionId){
 return  this.paymentAjaxService.deleteSavedCardPaymentIQ(userId, accountId, sessionId);
}



updateTransactionDetails(transactionDetails, transactionId) {
  this.paymentAjaxService.getTransactionIdStatusPaymentIQ(transactionDetails.playerId, transactionDetails.token, transactionId)
    .subscribe(
      (transactionData) => {
        if (transactionData && transactionData['txState'] === "SUCCESSFUL") {
          this.handleSuccessfulTransaction(transactionDetails, transactionId);
          this.numOfRequest = 0;
        } else {
          this.handleProcessingTransaction(transactionDetails, transactionId);
        }
      },
      (error) => {
        this.messageService.genericTransactionMessage();
      }
    );
}

handleSuccessfulTransaction(transactionDetails, transactionId) {
  this.messageService.successTransactionMessage({
    txnAmount: transactionDetails.currencySymbol + transactionDetails.selectedAmount,
    amount: transactionDetails.selectedAmount,
    transactionId: transactionId
  });
}

handleProcessingTransaction(transactionDetails, transactionId) {
  this.numOfRequest += 1;
  if (this.numOfRequest <= 5) {
    setTimeout(() => {
      this.updateTransactionDetails(transactionDetails, transactionId);
    }, 3000);
  }else {
    this.numOfRequest = 0;
    this.messageService.failureTransactionMessage();
  }
}

}
